import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import { ConsoleLimitsPage, consoleQuotasQueryOptions } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/limits")({
  // Intent preload — per-key tier / rate-limit / spend-cap snapshot.
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleQuotasQueryOptions());
  },
  component: ConsoleLimitsRoute,
});

function ConsoleLimitsRoute(): React.ReactElement {
  return <ConsoleLimitsPage />;
}
